// Wrapper component that shows desktop or mobile version based on screen size.
import BusSchedulesDesktop from './BusSchedulesDesktop';
import BusSchedulesMobile from './BusSchedulesMobile';

export default function BusSchedules() {
  return (
    <>
      {/* Desktop version - hidden on mobile/tablet */}
      <div className="hidden lg:block">
        <BusSchedulesDesktop />
      </div>

      {/* Mobile version - hidden on desktop */}
      <div className="lg:hidden">
        <BusSchedulesMobile />
      </div>
    </>
  );
}
